module.exports = __webpack_public_path__ + "static/media/munsonHausLogo copy.b7fdaf12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/munsonHausLogo copy.png
// module id = 25
// module chunks = 0